export type AvailableInventory = {
  maxQuantity?: number | null;
  sold?: number | null;
  held?: number | null;
  available?: number | null;
};

export function availableQuantity(item: AvailableInventory): number | null {
  if (Number(item.maxQuantity ?? 0) <= 0) return null;
  const available = Number(item.available);
  if (Number.isFinite(available)) return Math.max(0, available);
  return Math.max(0, Number(item.maxQuantity) - Number(item.sold ?? 0));
}

export function isUnavailable(item: AvailableInventory): boolean {
  return availableQuantity(item) === 0;
}

export function clampToAvailability(
  item: AvailableInventory,
  selected: number,
): number {
  const available = availableQuantity(item);
  return available === null
    ? Math.max(0, selected)
    : Math.max(0, Math.min(selected, available));
}
